<template>
    <el-container class="index">
        <!-- Header start -->
        <el-header
            class="header"
            style="line-height: 3.75rem;height: 3.75rem !important;"
        >
            <!-- 站点Logo -->
            <div class="el-logo">
                <el-link
                    href="/index"
                    target="_self"
                    :underline="false"
                >
                    <el-image
                        :src="src"
                        alt=""
                    />
                </el-link>
            </div>
            <!-- 导航菜单 -->
            <el-menu
                id="header-menu"
                default-active="1"
                class="el-menu el-dis"
                mode="horizontal"
            >
                <el-menu-item index="1">
                    <el-link
                        href="/index?vpath=/&vmode=1"
                        target="_self"
                    >
                        {{ $t('message.headerMenu') }}
                    </el-link>
                </el-menu-item>
            </el-menu>
            <!-- 用户栏 -->
            <div
                class="el-user"
                @mouseover="showLogin"
                @mouseleave="hideLogin"
            >
                <el-avatar
                    class="el-avatar el-xd-login"
                    icon="el-icon-user-solid"
                    default="Hell"
                    :src="user.userheader"
                />
                <el-name class="el-name">
                    {{ user.username }}
                    <el-image
                        :src="arrow_down"
                        style="height: 1rem;margin-left: .3125rem;"
                    />
                </el-name>
                <div
                    class="el-login"
                    style="display: none;"
                >
                    <el-header class="el-login-user">
                        <el-row
                            :gutter="5"
                            style="padding-top: .9375rem;"
                        >
                            <el-col
                                :span="5"
                                :push="1"
                            >
                                <el-avatar
                                    class="el-avatar  x-larger el-xd-login"
                                    icon="el-icon-user-solid"
                                    default="Hell"
                                    :src="user.userheader"
                                />
                            </el-col>
                            <el-col
                                :span="19"
                                :pull="6"
                                style="color:#ffffff;text-align: right;"
                            >
                                {{ user.username }}
                            </el-col>
                        </el-row>
                    </el-header>
                    <el-row class="el-user-logout">
                        <el-col
                            :span="24"
                            :push="0"
                        >
                            <el-link
                                href="#"
                                :underline="false"
                                @click.native="logout"
                            >
                                {{ $t('message.headerLoginOut') }}
                            </el-link>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="el-lang">
                <el-image
                    :src="langFlag"
                    style="width: 1.875rem;top: 0px;visibility: hidden;"
                />
                <el-select
                    v-model="value"
                    :placeholder="$t('message.headerlangSelect')"
                    style="position: relative;top: -2.8125rem;width: 6.875rem;"
                    @change="langChange"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :selected="$env==item.value||$i18n.locale==item.value"
                        :value="item.value"
                        :label="item.label"
                    />
                </el-select>
            </div>
            <div class="el-skin" />
        </el-header>
        <!-- Header end -->

        <el-container class="body">
            <!-- Side start -->
            <el-aside
                class="el-nav-menu"
                style="min-width: 15.625rem;"
            >
                <!--已用空间-->
                <el-row class="tac">
                    <el-col>
                        <el-menu
                            mode="vertical"
                            text-color=""
                            active-text-color="#409EFF"
                            background-color=""
                            :default-active="mainActive"
                            :default-openeds="[1]"
                            :router="true"
                        >
                            <el-menu-item index="/index?vpath=/&vmode=1">
                                <template slot="title">
                                    <i class="el-icon-folder" />
                                    <span class="indexMenu">{{ $t('message.sideMenuFileName') }}</span>
                                </template>
                            </el-menu-item>
                            <el-menu-item index="/colle?vpath=/&vmode=3">
                                <template slot="title">
                                    <i class="el-icon-delete-solid" />
                                    <span class="colleMenu">{{ $t('message.sideMenuCollectName') }}</span>
                                </template>
                            </el-menu-item>
                        </el-menu>
                    </el-col>
                </el-row>
                <div class="el-disk-free">
                    <el-row class="xd-lrow xd-pos">
                        <el-col
                            :span="8"
                            class="txt-left"
                        >
                            {{ $t('message.sideUsedSpace') }}：
                        </el-col>
                        <el-col
                            :span="16"
                            style="padding-top: .875rem;"
                        >
                            <el-progress
                                :percentage="usedFree"
                                :show-text="false"
                                :status="diskFree.usedType"
                            />
                        </el-col>
                    </el-row>
                    <el-row class="xd-lrow">
                        <el-col
                            :span="16"
                            :push="8"
                            class="x-per el-disk-col-digit"
                        >
                            {{ diskFree.used }}{{ diskFree.unitUsed }}/{{ diskFree.total }}{{ diskFree.unitTotal }}
                        </el-col>
                    </el-row>
                    <!--下载空间-->
                    <el-row
                        class="xd-lrow xd-pos"
                        style="margin-top: .625rem"
                    >
                        <el-col
                            :span="8"
                            class="txt-left"
                        >
                            {{ $t('message.sideDownloadSpace') }}：
                        </el-col>
                        <el-col
                            :span="16"
                            style="padding-top: .875rem;"
                        >
                            <el-progress
                                :percentage="downFree"
                                :show-text="false"
                                :status="diskDownload.usedType"
                            />
                        </el-col>
                    </el-row>
                    <el-row class="xd-lrow">
                        <el-col
                            :span="16"
                            :push="8"
                            class="x-per el-disk-col-digit"
                            style="margin-top: 0;"
                        >
                            {{ diskDownload.used }}{{ diskDownload.unitUsed }}/{{ diskDownload.total }}{{ diskDownload.unitTotal }}
                        </el-col>
                    </el-row>
                    <el-row class="xd-lrow xd-notice">
                        <el-col :span="24">
                            <p>{{ $t('message.sideMonthlyDownloadNotice') }}</p>
                        </el-col>
                    </el-row>
                </div>
            </el-aside>
            <!-- Side end -->

            <!-- Main start -->
            <el-main style="font-size: 1rem;">
                <el-header class="el-main-header">
                    <!-- 开始选择元素 -->
                    <el-row
                        v-if="isNotDirType1"
                        :gutter="1"
                        justify="start"
                        class="el-left el-main-header-left"
                    >
                        <!-- 上传文件 -->
                        <el-col :span="5">
                            <el-button
                                class="el-upload-button"
                                type="primary"
                                size="small"
                                icon="el-icon-upload"
                                :title="$t('message.mainUpload')"
                            >
                                <div class="el-input-file">
                                    <input
                                        type="file"
                                        multiple
                                        @change="uploadEngine($event,{})"
                                    >
                                </div>
                                <div class="el-input-text">
                                    {{ $t('message.mainUpload') }}
                                </div>
                            </el-button>
                        </el-col>

                        <!-- 新建文件夹 -->
                        <el-col :span="5">
                            <el-button
                                type="primary"
                                size="small"
                                class="el-folder-add"
                                icon="el-icon-folder-add"
                                :title="$t('message.mainBuildDir')"
                                @click="folderMaker"
                            >
                                {{ $t('message.mainBuildDir') }}
                            </el-button>
                        </el-col>

                        <!-- 批量删除 -->
                        <el-col
                            :span="4"
                            :push="0"
                        >
                            <el-button
                                type="primary"
                                size="small"
                                icon="el-icon-delete"
                                :title="$t('message.mainFileDel')"
                                class="el-fold-del"
                                style="display: none;"
                                @click="deleteFile"
                            >
                                {{ $t('message.mainFileDel') }}
                            </el-button>
                        </el-col>
                    </el-row>

                    <el-row class="el-right el-main-header-right">
                        <el-col>
                            <el-input
                                v-model="keyword"
                                class="el-search"
                                type="text"
                                :placeholder="$t('message.mainSearch')"
                                suffix-icon="el-icon-search"
                                @keyup.enter.native="keywordSearch($event)"
                            />
                        </el-col>
                    </el-row>
                </el-header>
                <el-container>
                    <el-row
                        class="el-table-title"
                        :gutter="0"
                    >
                        <el-col
                            :span="16"
                            :push="0"
                            :pull="1"
                        >
                            <div>
                                <el-row
                                    :gutter="0"
                                    justify="start"
                                    type="flex"
                                >
                                    <el-col
                                        v-if="tableHead.allBack"
                                        :span="2"
                                        :pull="0"
                                        :push="0"
                                        class="el-text-align"
                                    >
                                        <div
                                            class="el-active"
                                            @click="gotoPrev"
                                        >
                                            {{ $t('message.mainReturn') }}
                                        </div>
                                    </el-col>
                                    <el-col
                                        v-if="tableHead.allBack"
                                        :span="1"
                                        :pull="0"
                                        style="text-align: center"
                                    >
                                        <div>|</div>
                                    </el-col>
                                    <el-col
                                        v-if="tableHead.allBackAtSearch"
                                        :span="2"
                                        :pull="0"
                                        style="text-align: center"
                                    >
                                        <div
                                            class="el-active"
                                            @click="gotoRoot"
                                        >
                                            {{ $t('message.mainAllFile') }}
                                        </div>
                                    </el-col>
                                    <el-col
                                        v-if="tableHead.allBack"
                                        :span="21"
                                        :pull="0"
                                        class="el-text-align"
                                    >
                                        <div>
                                            <el-breadcrumb
                                                separator="/"
                                                style="height: 2rem;line-height: 2rem;text-align: left;"
                                            >
                                                <el-breadcrumb-item>
                                                    <div
                                                        class="el-active"
                                                        @click="gotoRoot"
                                                    >
                                                        {{ $t('message.mainAllFile') }}
                                                    </div>
                                                </el-breadcrumb-item>

                                                <el-breadcrumb-item
                                                    v-for="(_dir, key) in tableHead.curdirs"
                                                    :key="key"
                                                >
                                                    <div
                                                        v-if="_dir.id!=tableHead.curdir"
                                                        class="el-folder-style"
                                                        :fid="_dir.id"
                                                        :type="_dir.type"
                                                        @click="gotoFold"
                                                    >
                                                        {{ _dir.name }}
                                                    </div>
                                                    <div v-else>
                                                        {{ _dir.name }}
                                                    </div>
                                                </el-breadcrumb-item>
                                            </el-breadcrumb>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                        <el-col
                            :span="8"
                            :push="0"
                            style="float: right;"
                        >
                            <div style="margin-right: 1rem;text-align: right;">
                                {{ $t('message.mainLoaded') }}，{{ $t('message.mainTotal') }} {{ pager.total }} {{ $t('message.mainUnit') }}
                            </div>
                        </el-col>
                    </el-row>
                </el-container>
                <el-container>
                    <el-table
                        ref="selectData"
                        :stripe="false"
                        class="el-files"
                        :data="tableData"
                        :show-header="true"
                        :empty-text="loaded"
                        :row-class-name="tableRowClassName"
                        header-row-class-name="el-main-table-header"
                        @selection-change="selectionChange"
                        @cell-mouse-leave="editorHide"
                        @cell-mouse-enter="editorShow"
                    >
                        <el-table-column
                            width="30"
                            type="selection"
                        />
                        <el-table-column
                            v-if="tableHead.render===true"
                            prop="name"
                            :label="$t('message.mainFile')"
                            width="600"
                        >
                            <template slot-scope="scope">
                                <el-row
                                    :gutter="0"
                                    type="flex"
                                    justify="space-between"
                                >
                                    <el-col
                                        :span="2"
                                        :pull="0"
                                        style="margin-top: .375rem;"
                                    >
                                        <div v-if="scope.row.type == 1">
                                            <el-image
                                                :src="icons.fold"
                                                style="width: 1.5rem;"
                                            />
                                        </div>
                                        <div v-else-if="scope.row.type == 2">
                                            <el-image
                                                :src="icons.bin"
                                                style="width: 1.5rem;"
                                            />
                                        </div>
                                        <div v-else>
                                            <el-image
                                                :src="icons.text"
                                                style="width: 1.5rem;"
                                            />
                                        </div>
                                    </el-col>
                                    <el-col
                                        :span="18"
                                        :pull="2"
                                        :push="0"
                                        style="margin-top: .375rem;"
                                    >
                                        <div
                                            :style="addFolderStyle"
                                            @click="gotoFold"
                                            @keyup.enter="foldCommit($event)"
                                            @keyup.esc="folderPuller"
                                            v-html="scope.row.name"
                                        />
                                    </el-col>
                                    <el-col
                                        :span="2"
                                        :pull="2"
                                        :push="0"
                                    >
                                        <div
                                            @click="folderPusher($event.target)"
                                            v-html="scope.row.check"
                                        />
                                    </el-col>
                                    <el-col
                                        :span="2"
                                        :pull="0"
                                        :push="0"
                                    >
                                        <div
                                            @click="folderPuller"
                                            v-html="scope.row.close"
                                        />
                                    </el-col>
                                </el-row>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="size"
                            :label="$t('message.mainSize')"
                            width="180"
                        />
                        <el-table-column
                            prop="ctime"
                            :label="$t('message.mainDate')"
                        />
                        <el-table-column width="350">
                            <template slot-scope="scope">
                                <el-col
                                    :span="24"
                                    :push="0"
                                    class="xd-row-btn"
                                >
                                    <ul class="row-lan">
                                        <li
                                            v-show="scope.row.type==2 && scope.row.hash"
                                            @click="fileDownload(scope.row)"
                                        >
                                            {{ $t('message.fileDownload') }}
                                        </li>
                                        <li
                                            v-show="scope.row.dir_type!=1"
                                            @click="fileRemove(scope.row)"
                                        >
                                            {{ $t('message.fileDelete') }}
                                        </li>
                                        <li v-show="scope.row.dir_type!=1">
                                            <el-dropdown
                                                :hide-on-click="true"
                                                @command="fileAction"
                                            >
                                                <span>{{ $t('message.fileRemove') }}</span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item :command="beforeAction('move', scope.row)">
                                                        <span>{{ $t('message.messageMoveTo') }}</span>
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </li>
                                        <li @click="fileShare(scope.row)" v-show="fileShareShow && (scope.row.type==2)">
                                            {{ $t('message.fileShare') }}
                                        </li>
                                        <li
                                            v-show="scope.row.dir_type==1 && scope.row.type==2 && scope.row.hash"
                                            @click="fileClear(scope.row)"
                                        >
                                            {{ $t('message.fileClear') }}
                                        </li>
                                        <li
                                            v-show="scope.row.dir_type==1 && scope.row.type==2"
                                            style="width: 2rem;"
                                        >
                                            <div
                                                class="el-input-file"
                                                style="position: absolute;opacity: 0;width: 100%;"
                                            >
                                                <input
                                                    type="file"
                                                    style="width: 100%;"
                                                    @change="uploadEngine($event, scope.row)"
                                                >
                                            </div>
                                            {{ $t('message.fileReplace') }}
                                        </li>
                                    </ul>
                                </el-col>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->

                    <template>
                        <div class="el-table-pagination">
                            <el-pagination
                                layout="prev, pager, next"
                                :total="pager.total"
                                :page-size="pager.pageSize"
                                :background="true"
                                :next-text="$t('message.mainPageNext')"
                                :prev-text="$t('message.mainPagePrev')"
                                :pager-count="pager.pageCount"
                                :current-page="pager.currentPage"
                                :hide-on-single-page="true"
                                @current-change="currentChange"
                            />
                        </div>
                    </template>
                </el-container>
                <el-container
                    class="el-upload-alert"
                    style="display: none;"
                >
                    <el-header class="el-upload-header">
                        <div class="el-content-title">
                            {{ $t('message.mainUpload') }}
                        </div>
                        <div class="el-content-close">
                            <i
                                class="el-icon-close"
                                @click="progressClose"
                            />
                        </div>
                    </el-header>
                    <el-main class="el-upload-main">
                        <div
                            v-for="(item,key) in uploader.seqFiles"
                            :key="key"
                            class="el-progress-item"
                        >
                            <div class="el-progress-view">
                                <el-popover
                                    placement="bottom-end"
                                    width="200"
                                    trigger="hover"
                                    :visible-arrow="false"
                                    popper-class="el-upload-pop"
                                    :content="item.name"
                                >
                                    <div slot="reference">
                                        <div
                                            v-if="cutlen(item.name)>11"
                                            class="el-progress-name"
                                        >
                                            {{ key + 1 }}. <span
                                                style="color:#409EFF;"
                                            >{{ item.name.substr(0, 10) }}...</span>
                                        </div>
                                        <div
                                            v-else
                                            class="el-progress-name"
                                        >
                                            {{ key + 1 }}. <span style="color:#409EFF;">{{ item.name }}</span>
                                        </div>
                                        <div class="el-progress-value">
                                            <div :class="'percentage percentage'+item.index" />
                                        </div>
                                        <div class="el-progress-hit">
                                            <div>{{ item.per }}%</div>
                                        </div>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </el-main>
                </el-container>
            </el-main>
            <!-- Main end -->

            <!-- 移动至弹框模板 -->
            <el-dialog
                class="x-dialog"
                :title="$t('message.messageMovetion')"
                :center="false"
                :visible.sync="dialogVisible"
                width="30%"
            >
                <el-input
                    ref="lyinput"
                    v-model="filterKey"
                    style="top: -2rem;"
                    :placeholder="$t('message.filterNotice')"
                    @input="inputForceUpdate($event)"
                />
                <div class="x-dialog-tree">
                    <el-tree
                        ref="tree"
                        :data="folderLayers"
                        :props="defaultProps"
                        :filter-node-method="filterNode"
                        node-key="primary_id"
                        :check-on-click-node="true"
                        @node-click="setNodeKey"
                    >
                        <span
                            slot-scope="{node, data}"
                            class="custom-tree-node"
                        >
                            <span class="x-node">
                                <el-image
                                    :src="icons.fold"
                                    style="height: 1.375rem;width:1.375rem;top: .25rem;"
                                />
                                <span style="font-size: .9375rem;">{{ node.label }}</span>
                            </span>
                        </span>
                    </el-tree>
                </div>
                <div
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button
                        size="medium"
                        @click="movementCommitAndInit('c')"
                    >
                        {{ $t('message.cancel') }}
                    </el-button>
                    <el-button
                        size="medium"
                        type="primary"
                        @click="movementCommitAndInit('s')"
                    >
                        {{ $t('message.sure') }}
                    </el-button>
                </div>
            </el-dialog>

            <!-- 下载弹框模板 -->
            <div
                class="el-download"
                style="display: none;"
            >
                <div
                    role="alert"
                    class="el-message el-message--info"
                    style="top: 1.25rem; z-index: 2000;"
                >
                    <i class="el-message__icon el-icon-download" />
                    <p
                        data-v-47323bf2=""
                        style="width:100%;"
                    >
                        <span data-v-47323bf2="">{{ $t('message.messageLoaded') }}</span>
                        <span style="display: inline-block;width: 75%;">
                            <el-progress
                                :percentage="download.percent"
                                :status="download.status"
                            />
                        </span>
                    </p>
                </div>
            </div>

            <!-- 分享弹框模板 -->
            <el-dialog
                title="分享给其他人"
                :visible.sync="shareDialogVisible"
                width="18%"
                style="font-weight: bolder;"
                :show-close="false"
                custom-class="file-share"
                center
            >
                <p style="margin: 0;text-align: center;">
                    <img
                        :src="fileshare.img"
                        style="width: 200px;"
                    >
                </p>
                <p style="font-weight: bolder;color: #000;text-align: center;">
                    “{{ fileshare.name }}”
                </p>
                <p style="color: #000;">
                    {{ fileshare.remark }}
                </p>
                <p style="color: #c70000;">
                    {{ fileshare.tips }}
                </p>
                <span slot="footer">
                    <p
                        style="font-weight: bolder;color: #000;text-align: center;margin: 0;"
                        @click="fileShareClose"
                    >
                        <i
                            class="el-icon-circle-check"
                            style="font-size: 20px;vertical-align: middle;"
                        />&nbsp;&nbsp;完成
                    </p>
                </span>
            </el-dialog>
        </el-container>
    </el-container>
</template>
<script type="text/babel">
import ElCol from 'element-ui/packages/col/src/col'
import ElRow from 'element-ui/packages/row/src/row'
import ElTableColumn from 'element-ui/packages/table/src/table-column'
import { useGetter } from '../../api/local'
import { loginOut, valiLogin } from '../../api/login'
import {
    chunkData,
    diskCapacity,
    diskSpaceWatcher,
    downloader,
    fileClear,
    fileDeller,
    fileFinder,
    filePusher,
    fileShare,
    getCustomerBouns,
    getFlowInfo,
    getLayerOfFolder,
    prevRootRender,
    RootListRender,
    setItemParent,
    uploadCallBack,
    uploader
} from '../../api/upload'
import ElButton from '../../node_modules/element-ui/packages/button/src/button'
import ElContainer from '../../node_modules/element-ui/packages/container/src/main'
import ElHeader from '../../node_modules/element-ui/packages/header/src/main'
import ElImage from '../../node_modules/element-ui/packages/image/src/main'
import ElProgress from '../../node_modules/element-ui/packages/progress/src/progress'
import ElOption from '../../node_modules/element-ui/packages/select/src/option'
import ElSelect from '../../node_modules/element-ui/packages/select/src/select'
import arrow_down from '../assets/icons/arrow_down.png'
import binpng from '../assets/icons/btn_bin.png'
import btn_cancel from '../assets/icons/btn_cancel.png'
import btn_confirm from '../assets/icons/btn_confirm.png'
import textpng from '../assets/icons/btn_dat.png'
import deletepng from '../assets/icons/btn_delete.png'
import downloadpng from '../assets/icons/btn_download.png'
import foldpng from '../assets/icons/btn_file.png'
import morepng from '../assets/icons/btn_more.png'
import project from '../config/config'
import { langchange, langinit } from '../config/index'
export default {
    name: 'App',
    components: {
        ElTableColumn,
        ElOption,
        ElSelect,
        ElButton,
        ElRow,
        ElProgress,
        ElImage,
        ElCol,
        ElHeader,
        ElContainer
    },
    filters: {
        listReverse: function(list) {
            return list.reverse()
        }
    },
    /*  支持语言 */
    data: function() {
        return {
            loaded: this.$t('message.loading'),
            download: {
                percent: 0,
                status: ''
            },
            filterKey: '',
            defaultProps: {
                label: 'label',
                children: 'children'
            },
            folderLayers: [],
            currentNodeAttr: {},
            diskFree: {
                used: 0,
                total: 0,
                usedType: '',
                unitUsed: 'B',
                unitTotal: 'B',
                usedInt: 0,
                totalInt: 0
            },
            diskDownload: {
                used: 0,
                total: 0,
                usedType: '',
                unitUsed: 'B',
                unitTotal: 'B',
                usedInt: 0,
                totalInt: 0
            },
            arrow_down: arrow_down,
            uploader: {
                accept: [],
                maxSize: 5 * 1024 * 1024,
                seqFiles: [],
                maxLength: 5
            },
            user: {
                username: localStorage.getItem('username'),
                userheader: localStorage.getItem('userheader')
            },
            pager: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageCount: 7
            },
            keyword: '',
            selectData: [],
            tableHead: {
                render: true,
                allBack: false,
                allBackAtSearch: false,
                curdirs: [],
                curdir: '0'
            },
            addFolderStyle: {
                'height': '100%',
                'width': '100%'
            }, viewLoader: '',
            qrstyle: {
                'width': '10rem',
                'position': 'relative',
                'top': '0px',
                'left': '4.6875rem'
            },
            tableData: [],
            dirname: this.$t('message.mainBuildDir'),
            dirConfig: {
                maxLevel: 5
            },
            options: this.suplangs,
            nationcode: 86,
            src: project.cn,
            langFlag: this.suplangs[0].flag,
            value: (localStorage.lang || 'cn') === 'cn' ? '中文简体' : 'English',
            icons: {
                download: downloadpng,
                delete: deletepng,
                more: morepng,
                fold: foldpng,
                bin: binpng,
                text: textpng,
                confirm: btn_confirm,
                cancel: btn_cancel
            },
            dialogVisible: false,
            mainActive: '1',
            shareDialogVisible: false,
            fileShareShow:Number(localStorage.getItem('fileShareShow')),
            fileshare: {
                img: '',
                name: '',
                remark: '',
                tips: ''
            },
            isNotDirType1: true
        }
    },
    computed: {
        usedFree: function() {
            const percentage = parseInt((this.diskFree.usedInt / this.diskFree.totalInt) * 100)
            return percentage >= 100 ? 100 : percentage
        },
        downFree: function() {
            const percentage = parseInt((this.diskDownload.usedInt / this.diskDownload.totalInt) * 100)
            return percentage >= 100 ? 100 : percentage
        }
    },
    watch: {
        filterKey(val) {
            this.$refs.tree.filter(val)
        }
    },
    created() {
        const _this = this
        // 验证用户是否登录
        const userInfo = useGetter()
        if (userInfo) {
            const username = userInfo.username
            const nationcode = userInfo.usercode
            valiLogin(username, nationcode).then(function(response) {
                if (!(response && parseInt(response.data.error) === 0)) {
                    // 用户未登录
                    _this.$router.push({ name: 'login' })
                    return false
                }
            })
            _this.gotoFolder(0)
        }
    },
    mounted() {
        const _this = this
        const userInfo = useGetter()
        if (userInfo) {
            const nationcode = userInfo.usercode
            const userarea = userInfo.userarea

            langinit(userarea, _this)
            _this.getDiskSpace(nationcode)

            // 监听文件搜索
            jQuery('div.el-search').find('i.el-icon-search').on('click', function() {
                _this.keywordsSearch(_this.keyword)
            })
        }
    },
    methods: {
    // 进入文件夹
        gotoFolder(folderId, callable) {
            const _this = this
            const user = useGetter()
            const nationcode = user.usercode
            RootListRender(folderId, _this.pager, nationcode).then((res) => {
                if (res && parseInt(res.data.error) === 0) {
                    const wanted = res.data.data
                    // 当前文件夹
                    const currentFolder = wanted.currentFolder
                    // 面包屑
                    const folders = wanted.folders
                    // 数据列表
                    const list = wanted.data.list
                    // 分页信息
                    const page = wanted.data.page

                    /* 设置绑定 */
                    _this.tableHead.allBack = currentFolder.pid !== undefined
                    _this.tableHead.allBackAtSearch = false
                    _this.tableHead.curdir = currentFolder.id ? currentFolder.id : 0
                    _this.tableHead.curdirs = folders

                    _this.tableData = list
                    _this.isNotDirType1 = parseInt(currentFolder.dir_type) !== 1

                    _this.pager.total = parseInt(page.count)
                    _this.pager.pageSize = parseInt(page.pageSize)
                    _this.pager.currentPage = parseInt(page.currentPage)

                    if (!_this.pager.total) _this.loaded = _this.$t('message.loaded')

                    if (callable) callable()
                } else {
                    _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                }
            }, () => {
                _this.$message.error(_this.$t('message.messageActionError'))
            })
        },
        // 获取用户磁盘容量
        getDiskSpace(nationCode) {
            const _this = this
            diskSpaceWatcher(nationCode).then((res) => {
                if (res && parseInt(res.data.error) === 0) {
                    const usage = res.data.data.list
                    const download = res.data.data.download

                    _this.diskFree.used = usage.used
                    _this.diskFree.total = usage.total
                    _this.diskFree.usedInt = usage.usedInt
                    _this.diskFree.totalInt = usage.totalInt
                    _this.diskFree.unitUsed = usage.unitUsed
                    _this.diskFree.unitTotal = usage.unitTotal

                    _this.diskDownload.used = download.used
                    _this.diskDownload.total = download.total
                    _this.diskDownload.usedInt = download.usedInt
                    _this.diskDownload.totalInt = download.totalInt
                    _this.diskDownload.unitUsed = download.unitUsed
                    _this.diskDownload.unitTotal = download.unitTotal

                    if (parseInt((_this.diskFree.usedInt / _this.diskFree.totalInt) * 100) > 80) {
                        _this.diskFree.usedType = 'exception'
                    } else {
                        _this.diskFree.usedType = ''
                    }

                    if (parseInt((_this.diskDownload.usedInt / _this.diskDownload.totalInt) * 100) > 80) {
                        _this.diskDownload.usedType = 'exception'
                    } else {
                        _this.diskDownload.usedType = ''
                    }
                    return false
                } else {
                    _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                    return false
                }
            })
        },
        // 关键词搜索
        keywordsSearch(keywords) {
            const _this = this
            if (jQuery.trim(keywords) === '') {
                _this.$message.error(_this.$t('message.messageMissKeyWord'))
                return false
            }

            const user = useGetter()
            const nationcode = user.usercode
            _this.loaded = _this.$t('message.loading')
            fileFinder(keywords, _this.pager, nationcode).then((res) => {
                if (res && parseInt(res.data.error) === 0) {
                    const wanted = res.data.data
                    // 当前文件夹
                    const currentFolder = wanted.currentFolder
                    // 面包屑
                    const folders = wanted.folders
                    // 数据列表
                    const list = wanted.data.list
                    // 分页信息
                    const page = wanted.data.page

                    /* 设置绑定 */
                    _this.tableHead.allBack = false
                    _this.tableHead.allBackAtSearch = true
                    _this.tableHead.curdir = currentFolder.id ? currentFolder.id : 0
                    _this.tableHead.curdirs = folders

                    _this.tableData = list
                    _this.isNotDirType1 = parseInt(currentFolder.dir_type) !== 1

                    _this.pager.total = parseInt(page.count)
                    _this.pager.pageSize = parseInt(page.pageSize)
                    _this.pager.currentPage = parseInt(page.currentPage)

                    if (!_this.pager.total) _this.loaded = _this.$t('message.loaded')
                } else {
                    _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                }
            }, () => {
                _this.loaded = _this.$t('message.loaded')
            })
        },

        // 磁盘扩容
        dilatation() {
            const _this = this
            const h = _this.$createElement
            _this.$msgbox({
                title: '请选择扩容量',
                message: h('div', {
                    attrs: { 'class': 'el-dilatation-div' }
                }, [h('select', {
                    attrs: { 'id': 'el-dilatation-select' }
                }, [
                    h('option', { attrs: { 'value': '500', 'selected': 'selected' }}, '扩容500M'),
                    h('option', { attrs: { 'value': '1' }}, '扩容1GB'),
                    h('option', { attrs: { 'value': '2' }}, '扩容2GB'),
                    h('option', { attrs: { 'value': '3' }}, '扩容3GB'),
                    h('option', { attrs: { 'value': '4' }}, '扩容4GB'),
                    h('option', { attrs: { 'value': '5' }}, '扩容5GB')
                ])]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then((action) => {
                console.log(action)
                let nationCode = _this.$store.state.nation.code
                if (nationCode === 0 || isNaN(nationCode)) {
                    nationCode = 86
                }
                const spaceVal = jQuery('#el-dilatation-select').val()
                console.log(spaceVal)
                // 验证积分是否充足
                getCustomerBouns(spaceVal, nationCode).then((res) => {
                    if (res.data.error > 0) {
                        _this.$message.warning('积分不足')
                        return false
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }).catch((cancel) => {
                console.log(cancel)
            })
        },
        // 上传文件
        uploadEngine(e, row) {
            const queuedFiles = e.target.files
            const _this = this

            _this.uploader.seqFiles = []
            const valiTypes = _this.uploader.accept
            const maxLength = _this.uploader.maxLength
            const uploadSuccess = _this.getUrlSuccess
            const uploadError = _this.getUrlError
            const currentFold = isNaN(_this.tableHead.curdir) ? 0 : _this.tableHead.curdir
            // 单个文件大小
            let allUoloadSize = 0
            let nationCode = _this.$store.state.nation.code
            if (nationCode === 0 || isNaN(nationCode)) {
                nationCode = 86
            }
            if (queuedFiles.length > maxLength) {
                _this.$message.error(_this.$t('message.messageUploadOverLimit'))
                return false
            }
            jQuery.each(queuedFiles, function(i, ele) {
                allUoloadSize += parseInt(ele.size)
            })
            // 月流量
            getFlowInfo(nationCode).then((flow) => {
                if (flow) {
                    const status = parseInt(flow.data.status)
                    if (parseInt(flow.data.error) === 0) {
                        const flowSize = parseInt(flow.data.data.fileProps.allowMaxSize)
                        const isFlow = status !== 2011
                        // 检查文件大小 (未超过)
                        for (let i = 0; i < queuedFiles.length; i++) {
                            if (valiTypes.length > 0 && valiTypes.indexOf(queuedFiles[i].type) === -1) {
                                _this.$message.error(_this.$t('message.messageUploadTypeError'))
                                return false
                            }
                            if (queuedFiles[i].size > flowSize) {
                                _this.$message.error(isFlow ? _this.$t('message.messageMonthFlowLimit') : _this.$t('message.messageUploadMaxSize'))
                                return false
                            }
                        }
                        if (allUoloadSize > flowSize) {
                            _this.$message.error(isFlow ? _this.$t('message.messageMonthFlowLimit') : _this.$t('message.messageUploadMaxSize'))
                            return false
                        }
                        // 检查用户可用空间
                        diskCapacity(nationCode, allUoloadSize).then(function(diskRes) {
                            if (diskRes && parseInt(diskRes.data.error) > 0) {
                                _this.$message.error(_this.$t('message.messageDiskFreeFull'))
                                return false
                            }
                            // 2. 效验文件
                            for (let i = 0; i < queuedFiles.length; i++) {
                                const Reader = new FileReader()
                                Reader.readAsText(queuedFiles[i])
                                Reader.onload = function() {
                                    const parmas = {
                                        name: queuedFiles[i].name,
                                        size: queuedFiles[i].size,
                                        hash: _this.$md5(this.result),
                                        index: i,
                                        per: 0
                                    }
                                    _this.uploader.seqFiles.push(parmas)
                                    jQuery('section.el-upload-alert').show()
                                    const fileOrFolderId = row.id ? row.id : currentFold
                                    uploader(parmas, nationCode, fileOrFolderId, uploadSuccess, uploadError).then((success) => {
                                        if (parseInt(success.data.error) === 0) {
                                            const data = success.data.data
                                            if (parseInt(data.status) === 0) {
                                                jQuery('div.el-progress-value').find('.percentage' + data.uid).css({
                                                    'width': '100%'
                                                })
                                                jQuery.each(_this.uploader.seqFiles, function(k, v) {
                                                    if (parseInt(v.index) === parseInt(data.uid)) {
                                                        _this.uploader.seqFiles[k].per = 100
                                                    }
                                                })
                                                uploadCallBack(nationCode, data.tid, fileOrFolderId).then(function(res) {
                                                    if (res && parseInt(res.data.error) === 0) {
                                                        _this.$message.success(_this.$t('message.messageUploadSuccess'))
                                                        _this.gotoFolder(currentFold)
                                                        _this.getDiskSpace(nationCode)
                                                    } else {
                                                        _this.$message.error(res.data.msg || _this.$t('message.messageUploadFailed'))
                                                    }
                                                })
                                            } else {
                                                // 文件压缩
                                                const ziper = new _this.$zip()
                                                ziper.file(queuedFiles[i].name, queuedFiles[i])
                                                ziper.generateAsync({
                                                    type: 'blob',
                                                    compression: 'DEFLATE',
                                                    compressionOptions: {
                                                        level: 9
                                                    }
                                                }).then(function(content) {
                                                    // 上传至S3
                                                    const uFile = new File([content], queuedFiles[i].name, { type: 'zip' })
                                                    jQuery.ajax({
                                                        async: true,
                                                        contentType: false,
                                                        type: 'put',
                                                        url: data.url,
                                                        data: uFile,
                                                        processData: false,
                                                        success: function(res, status, success) {
                                                            if (parseInt(success.readyState) === 4 && parseInt(success.status) === 200) {
                                                                // 通知服务端
                                                                uploadCallBack(nationCode, data.tid, fileOrFolderId).then(function(res) {
                                                                    if (res && parseInt(res.data.error) === 0) {
                                                                        _this.$message.success(_this.$t('message.messageUploadSuccess'))
                                                                        _this.gotoFolder(currentFold)
                                                                        _this.getDiskSpace(nationCode)
                                                                    } else {
                                                                        _this.$message.error(res.data.msg || _this.$t('message.messageUploadFailed'))
                                                                    }
                                                                })
                                                            }
                                                        },
                                                        error: function(res, status, request) {
                                                            _this.$message.error(_this.$t('message.messageUploadFailed'))
                                                            return false
                                                        },
                                                        xhr: function() {
                                                            const xhr = jQuery.ajaxSettings.xhr()
                                                            xhr.upload.onprogress = function(evt) {
                                                                const loaded = (evt.loaded / evt.total) * 100
                                                                jQuery('div.el-progress-value').find('.percentage' + data.uid).css({
                                                                    'width': `${loaded}` + '%'
                                                                })
                                                                jQuery.each(_this.uploader.seqFiles, function(k, v) {
                                                                    if (parseInt(v.index) === parseInt(data.uid)) {
                                                                        _this.uploader.seqFiles[k].per = Math.floor(loaded)
                                                                    }
                                                                })
                                                            }
                                                            return xhr
                                                        }
                                                    })
                                                })
                                            }
                                        } else {
                                            _this.$message.error(success.data.msg || _this.$t('message.messageUploadFailed'))
                                            return false
                                        }
                                    }).catch(() => {
                                        _this.$message.error(_this.$t('message.messageUploadFailed'))
                                        return false
                                    })
                                }
                            }
                        })
                    } else {
                        _this.$message.error(_this.$t('message.messageActionError'))
                    }
                } else {
                    _this.$message.error(_this.$t('message.messageActionError'))
                }
            })
        },
        getUrlSuccess(res, i) {
        },
        getUrlError(res, i) {
        },
        // 下载文件
        fileDownload(evt) {
            const _this = this
            _this.download.percent = 0
            _this.download.status = ''
            const domDiv = document.createElement('div')
            domDiv.innerHTML = evt.name
            const downloadLink = jQuery(domDiv).find('.el-file-style')
            const key = downloadLink.attr('key')
            const name = downloadLink.attr('name')
            const nationcode = this.$store.state.nation.code

            // 下载量限制&流量限制
            getFlowInfo(nationcode, key).then((flow) => {
                if (flow && parseInt(flow.data.error) === 0) { // 未超过
                    const status = flow.data.status
                    const isFlow = parseInt(status) !== 2011
                    const fileSize = parseInt(flow.data.data.fileProps.size)
                    const downloadLimitSize = parseInt(flow.data.data.fileProps.allowMaxSize)
                    if (fileSize > downloadLimitSize) {
                        _this.$message.warning(isFlow ? _this.$t('message.messageMonthFlowLimit') : _this.$t('message.messageDownloadMax'))
                        return false
                    }
                    jQuery('div.el-download').show()
                    downloader(key, name, nationcode).then((response) => {
                        const downloadUrl = response.data.data.url
                        _this.download.percent = 0
                        _this.download.status = ''
                        if (downloadUrl) {
                            const jsZip = new _this.$zip()
                            const xmlhttp = new XMLHttpRequest()
                            xmlhttp.responseType = 'blob'
                            xmlhttp.open('GET', downloadUrl, true)
                            xmlhttp.onreadystatechange = function(evt) {
                                const res = evt.target
                                if (parseInt(res.readyState) === 4 && parseInt(res.status) === 200) {
                                    jsZip.loadAsync(res.response).then(function(zip) {
                                        if (zip.files) {
                                            for (const keyName in zip.files) {
                                                var stream = zip.files[keyName]
                                                stream.async('blob').then(function(blob) {
                                                    const url = window.URL.createObjectURL(blob)
                                                    const link = document.createElement('a')
                                                    link.style.display = 'none'
                                                    link.href = url
                                                    link.setAttribute('download', name)
                                                    document.body.appendChild(link)
                                                    link.click()

                                                    _this.getDiskSpace(nationcode)
                                                    return false
                                                })
                                                return false
                                            }
                                        } else {
                                            _this.$message.error(_this.$t('message.messageDownloadFailed'))
                                            return false
                                        }
                                    })
                                }
                            }
                            xmlhttp.onprogress = function(pregressEvent) {
                                const percent = Math.floor(pregressEvent.loaded / pregressEvent.total) * 100
                                _this.download.percent = percent
                                if (percent === 100) {
                                    _this.download.status = 'success'
                                    setTimeout(function() {
                                        jQuery('div.el-download').hide()
                                    }, 5000)
                                }
                            }
                            xmlhttp.send(null)
                        } else {
                            _this.$message.error(_this.$t('message.messageDownloadFailed'))
                            return false
                        }
                    }).catch(function() {
                        _this.$message.error(_this.$t('message.messageDownloadFailed'))
                        return false
                    })
                } else {
                    _this.$message.warning(_this.$t('message.systemDownloadOverFlow'))
                    return false
                }
            })
        },
        // 操作文件
        fileAction(data) {
            const _this = this
            _this.folderLayers = [
                {
                    primary_id: '0',
                    parent_id: '0',
                    ext_name: '',
                    type: '1',
                    size: '0',
                    children: [],
                    label: _this.$t('message.sideMenuFileName')
                }
            ]
            const itemid = data.row.id
            const nationcode = isNaN(_this.$store.state.nation.code) ? 86 : _this.$store.state.nation.code
            const languageid = 1
            switch (data.command) {
                case 'move':
                    _this.$store.state.movement.item = 0
                    _this.$store.state.movement.pid = 0
                    getLayerOfFolder(itemid, nationcode, languageid).then((res) => {
                        if (res && res.data.data) {
                            const list = res.data.data.list
                            _this.folderLayers[0]['children'] = list
                            _this.currentNodeAttr['itemid'] = data.row.id
                            _this.currentNodeAttr['pid'] = data.row.pid
                            _this.currentNodeAttr['name'] = data.row.name.replace(/(<\/?a.*?>)|(<\/?span.*?>)/g, '')
                            _this.dialogVisible = true
                        }
                    }).catch(() => {
                        _this.$message.error(_this.$t('message.messageServerIsBusy'))
                    })
                    break
                default :
                    break
            }
        },
        setNodeKey(obj, node, self) {
            const _this = this
            const nodeAttr = _this.currentNodeAttr
            if (nodeAttr.itemid !== undefined && nodeAttr.pid !== undefined) {
                _this.currentNodeAttr['tarid'] = obj.primary_id
            } else {
                _this.dialogVisible = false
                _this.$message.error(_this.$t('message.messageActionError'))
                return false
            }
        },
        movementCommitAndInit(command) {
            const _this = this
            if (command === 'c') {
                _this.dialogVisible = false
                return false
            }

            const nationcode = isNaN(_this.$store.state.nation.code) ? 86 : _this.$store.state.nation.code
            const actFolder = _this.tableHead.curdir
            const languageid = 1
            if (
                (_this.currentNodeAttr['itemid'] === _this.currentNodeAttr['tarid']) || (_this.currentNodeAttr['pid'] === _this.currentNodeAttr['tarid'])
            ) {
                _this.$message.warning(_this.$t('message.messageMoveSame'))
                return false
            }
            _this.dialogVisible = false
            setItemParent(_this.currentNodeAttr, nationcode, languageid).then((res) => {
                if (res && parseInt(res.data.error) === 0) {
                    _this.loaded = _this.$t('message.loading')
                    _this.gotoFolder(actFolder)
                } else {
                    _this.$message.error(res.data.msg || _this.$t('message.messageActionError'))
                }
            }).catch(() => {
                _this.$message.error(_this.$t('message.messageActionError'))
            })
        },
        beforeAction(command, row) {
            return {
                command: command,
                row: row
            }
        },
        progressClose() {
            jQuery('section.el-upload-alert').hide()
            this.uploader.percentage = 0
            this.uploader.seqFiles = []
        },
        // 文件分享
        fileShare(row) {
            const _this = this
            const id = row.id
            fileShare(id).then((response) => {
                if (parseInt(response.data.error)) {
                    _this.$message.warning(response.data.msg)
                    return false
                }
                _this.shareDialogVisible = true
                _this.fileshare = {
                    img: response.data.data.qrcode,
                    name: response.data.data.name,
                    remark: response.data.data.remark,
                    tips: response.data.data.tips
                }
                return true
            })
        },
        // 关闭文件分享弹框
        fileShareClose() {
            this.shareDialogVisible = false
        },
        // 清空文件
        fileClear(row) {
            const _this = this
            fileClear(row.id).then((response) => {
                if (parseInt(response.data.error)) {
                    _this.$message.warning(response.data.msg)
                    return false
                }
                _this.gotoFolder(row.pid)
            })
        },
        // 删除单行
        fileRemove(row) {
            const _this = this
            const selid = []
            const nationcode = _this.$store.state.nation.code
            const actFolder = _this.tableHead.curdir
            _this.$confirm(_this.$t('message.mainConfirmDel'), _this.$t('message.messageBoxTitle'), {
                confirmButtonText: _this.$t('message.sure'),
                cancelButtonText: _this.$t('message.cancel'),
                customClass: 'x-notice'
            }).then(function() {
                selid.push(row.id)
                fileDeller(selid, nationcode).then((res) => {
                    if (res && parseInt(res.data.error) === 0) {
                        _this.loaded = _this.$t('message.loading')
                        _this.gotoFolder(actFolder)
                        _this.getDiskSpace(nationcode)
                    } else {
                        _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                        return false
                    }
                })
            })
        },
        // 删除多行
        deleteFile() {
            const _this = this
            const selid = []
            const nationcode = _this.$store.state.nation.code
            const actFolder = _this.tableHead.curdir
            jQuery.each(_this.selectData, function(i, e) {
                selid.push(e.id)
            })
            _this.$confirm(_this.$t('message.mainConfirmDel'), _this.$t('message.messageBoxTitle'), {
                confirmButtonText: _this.$t('message.sure'),
                cancelButtonText: _this.$t('message.cancel'),
                customClass: 'x-notice'
            }).then(() => {
                fileDeller(selid, nationcode).then((res) => {
                    if (res && parseInt(res.data.error) === 0) {
                        _this.gotoFolder(actFolder)
                        _this.getDiskSpace(nationcode)
                    } else {
                        _this.$message.error(_this.$t('message.messageServerIsBusy'))
                        return false
                    }
                }, () => {
                    _this.$message.error(_this.$t('message.messageServerIsBusy'))
                })
            }).catch(() => {
            })
        },
        // table 复选框点击
        selectionChange(selection) {
            this.selectData = selection
            if (this.selectData.length > 0) {
                jQuery('button.el-fold-del').show()
            } else {
                jQuery('button.el-fold-del').hide()
            }
        },
        // 分页组件
        currentChange(currentPage) {
            const _this = this
            const cdir = _this.tableHead.curdir
            const nationcode = _this.$store.state.nation.code
            const pager = {
                currentPage: currentPage,
                pageSize: 10,
                total: 0
            }
            _this.loaded = _this.$t('message.loading')// 加载中...
            chunkData(cdir, pager, nationcode).then((res) => {
                if (res && parseInt(res.data.error) === 0) {
                    const wanted = res.data.data
                    // 数据列表
                    const list = wanted.data.list
                    // 分页信息
                    const page = wanted.data.page
                    // 设置绑定
                    /*  返回按钮隐藏/显示 */

                    /*  list设置 */
                    _this.tableData = list

                    /*  page */
                    _this.pager.total = parseInt(page.count)
                    _this.pager.currentPage = parseInt(page.currentPage)
                    _this.pager.pageSize = parseInt(page.pageSize)

                    if (page.count < 1) {
                        _this.loaded = _this.$t('message.loaded')
                    }
                    /*  文件夹设置 */
                } else {
                    _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                    _this.loaded = _this.$t('message.loaded')// 暂无数据...
                }
            }, () => {
                _this.$message.error(_this.$t('message.messageServerIsBusy'))
                _this.loaded = _this.$t('message.loaded')// 暂无数据...
            })
        },
        foldCommit(e) {
            if (e && parseInt(e.keyCode) === 13) {
                const _this = this
                const folderkey = jQuery(e.target).val()
                if (jQuery.trim(folderkey) === '') {
                    _this.$message.error(_this.$t('message.messageEmptyFolderName'))
                    return
                }
                const folder = {
                    pdir: isNaN(_this.tableHead.curdir) ? 0 : _this.tableHead.curdir,
                    foldername: folderkey,
                    type: 1
                }
                const nationcode = isNaN(_this.$store.state.nation.code) ? 86 : _this.$store.state.nation.code
                filePusher(folder, nationcode).then(function(response) {
                    if (response && parseInt(response.data.error) === 0) {
                        const addRowRes = response.data.data.list
                        const name = addRowRes.name
                        addRowRes.size = '-'
                        addRowRes.name = "<router-link fid='" + addRowRes.id + "' type='" + addRowRes.type + "'  class='el-folder-style'>" + name + '</router-link>'
                        _this.tableData.shift()
                        _this.tableData.unshift(addRowRes)
                        // _this.$forceUpdate();
                        _this.pager.total = _this.pager.total + 1
                        _this.$store.state.table.option = {}
                    } else {
                        if (parseInt(response.data.status) === 2022) {
                            _this.$message.error(_this.$t('message.messageSameFolderName'))
                        } else if (parseInt(response.data.status) === 2014) {
                            _this.$message.error(_this.$t('message.messageFolderLayersLimit'))
                        } else {
                            _this.$message.error(response.data.msg || _this.$t('message.messageServerIsBusy'))
                        }
                        return false
                    }
                }
                ).catch((err) => { console.log(err) })
            }
        },
        // 提交文件夹
        folderPusher(e) {
            // 文件夹名称
            const _this = this
            const folderkey = jQuery(e).parents('div.el-col').prev('div.el-col').find('input').val()
            if (jQuery.trim(folderkey) === '') {
                _this.$message.error('请输入文件夹名称')
                return
            }
            const folder = {
                pdir: isNaN(_this.tableHead.curdir) ? 0 : _this.tableHead.curdir,
                foldername: folderkey,
                type: 1
            }
            const nationcode = _this.$store.state.nation.code
            filePusher(folder, nationcode).then(function(response) {
                if (response && parseInt(response.data.error) === 0) {
                    const addRowRes = response.data.data.list
                    const name = addRowRes.name
                    addRowRes.size = '-'
                    addRowRes.name = "<router-link fid='" + addRowRes.id + "' type='" + addRowRes.type + "'  class='el-folder-style'>" + name + '</router-link>'
                    _this.tableData.shift()
                    _this.tableData.unshift(addRowRes)
                    // _this.$forceUpdate();
                    _this.pager.total = _this.pager.total + 1
                    _this.$store.state.table.option = {}
                } else {
                    if (parseInt(response.data.status) === 2022) {
                        _this.$message.error(_this.$t('message.messageSameFolderName'))
                    } else {
                        _this.$message.error(response.data.msg || _this.$t('message.messageFolderLayersLimit'))
                    }
                    return false
                }
            }
            ).catch((err) => { console.log(err) })
        },
        // 取消文件夹
        folderPuller(e) {
            const _this = this
            _this.tableData.shift()
            const addRow = _this.$store.state.table.option
            if (addRow.id !== undefined) {
                _this.tableData.push(addRow)
                _this.$store.state.table.option = {}
            }
        },
        // 创建文件夹
        folderMaker() {
            const _this = this
            const rowObj = jQuery('div.el-files')
                .find('div.el-table__fixed-body-wrapper')
                .find('table.el-table__body')
                .find('tr.el-table__row.success-row')
            console.log(rowObj.length)
            const KeyFold = jQuery('.el-files.el-table').find('input.el-table-folder-input')
            if (KeyFold.length > 0) {
                KeyFold.focus().select()
                return false
            }

            const addRow = {
                ctime: '-',
                ext: '',
                id: '',
                name: "<input class='el-table-folder-input' value='" + this.dirname + "' autofocus maxlength='18' size='small'  placeholder='" + this.dirname + "' />",
                pid: _this.tableHead.curdir,
                size: '-',
                type: '1',
                userid: localStorage.getItem('userid'),
                check: "<image class='el-icon-check el-active' src='" + this.icons.confirm +
					"'  style='margin-top: 10px;' />",
                close: "<image class='el-icon-close el-active' src='" + this.icons.cancel +
					"' style='margin-top: 10px;' />"
            }
            if (rowObj.length >= 10) {
                const RemoveRow = _this.tableData.slice(-1)
                _this.$store.state.table.option = RemoveRow[0]
                _this.tableData.pop()
            }

            _this.tableData.unshift(addRow)
            setTimeout(function() {
                jQuery('input.el-table-folder-input').focus().select()
            }, 500)
        },
        // 返回上一级
        gotoPrev(e) {
            const _this = this
            const userInfo = useGetter()
            if (userInfo) {
                const actFolder = _this.tableHead.curdir
                const nationcode = userInfo.usercode
                const pager = {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                }
                _this.loaded = _this.$t('message.loading')// 加载中...
                prevRootRender(actFolder, pager, nationcode).then((res) => {
                    if (res && parseInt(res.data.error) === 0) {
                        const wanted = res.data.data
                        // 当前文件夹
                        const currentFolder = wanted.currentFolder
                        // 面包屑
                        const folders = wanted.folders
                        // 数据列表
                        const list = wanted.data.list
                        // 分页信息
                        const page = wanted.data.page

                        /* 设置绑定 */
                        _this.tableHead.allBack = currentFolder.pid !== undefined
                        _this.tableHead.allBackAtSearch = false
                        _this.tableHead.curdir = currentFolder.id ? currentFolder.id : 0
                        _this.tableHead.curdirs = folders

                        _this.tableData = list
                        _this.isNotDirType1 = parseInt(currentFolder.dir_type) !== 1

                        _this.pager.total = parseInt(page.count)
                        _this.pager.pageSize = parseInt(page.pageSize)
                        _this.pager.currentPage = parseInt(page.currentPage)

                        if (!_this.pager.total) _this.loaded = _this.$t('message.loaded')
                    } else {
                        _this.$message.error(res.data.msg || _this.$t('message.messageServerIsBusy'))
                    }
                }, () => {
                    _this.$message.error(_this.$t('message.messageActionError'))
                })
            }
        },
        // 进入目录
        gotoFold(e) {
            const _this = this
            const userInfo = useGetter()
            if (userInfo) {
                const sel = jQuery(e.target)
                const isfolder = sel.hasClass('el-folder-style')
                const folderid = parseInt(sel.attr('fid'))
                const type = parseInt(sel.attr('type'))

                if (isfolder && type === 1) {
                    _this.loaded = _this.$t('message.loading')// 加载中...
                    _this.gotoFolder(folderid)
                }
            }
        },
        // 前往根目录
        gotoRoot() {
            const _this = this
            _this.loaded = _this.$t('message.loading')// 加载中...
            _this.gotoFolder(0)
        },
        editorShow(row, column, cell, event) {
            // 鼠标移入显示编辑label
            jQuery(cell).find('div.x-table-hidden').css({ 'visibility': 'visible' })
        },
        editorHide(row, column, cell, event) {
            // 鼠标移出隐藏编辑label
            jQuery(cell).find('div.x-table-hidden').css({ 'visibility': 'hidden' })
        },
        langChange(item) {
            langchange(item, this)
        },
        showLogin() {
            // 用户信息窗显示
            jQuery('.el-login').show()
        },
        hideLogin() {
            // 用户信息窗隐藏
            jQuery('.el-login').hide()
        },
        logout() {
            const _this = this
            const userInfo = useGetter()
            if (userInfo) {
                const user = userInfo.username
                loginOut(user).then(
                    function(response) {
                        if (response && parseInt(response.data.error) === 0 && parseInt(response.data.status) === 2007) {
                            /!*注销成功*!/
                            // 1) 记录用户状态
                            _this.$store.commit('xlogout', {})
                            // 2) 跳转至登录页
                            _this.qrstyle = {}
                            _this.$router.replace({ path: '/' })
                        } else {
                            _this.$alert(_this.$t('message.messageServerIsBusy'))
                        }
                    }
                )
            }
        },
        keywordSearch(e) {
            this.keywordsSearch(e.target.value)
        },
        inputForceUpdate(e) {
            this.$forceUpdate()
        },
        filterNode(value, data) {
            console.log(value)
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        renderContent(h, { node, data, store }) {
            // return ();
        },
        cutlen(str) {
            let strlen = 0
            for (let i = 0; i < str.length; i++) {
                // 如果是汉字，则字符串长度加2
                if (str.charCodeAt(i) > 255) {
                    strlen += 2
                } else {
                    strlen++
                }
            }
            return strlen
        },
        tableRowClassName({ row, rowIndex }) {
            return 'success-row'
        }
    }
}
</script>

<style lang="css">
    @import '../assets/css/index/index.css';
    @import '../assets/css/index/header.css';
    @import '../assets/css/index/side.css';
    @import '../assets/css/index/main-common.css';

    .el-header .el-account-rem {
        text-align: left !important;
    }

    .x-dialog.el-dialog__wrapper .el-dialog__title {
        font-size: 1rem !important;
    }

    .x-notice div.el-message-box__title span {
        font-size: 1rem !important;
    }

    span.el-breadcrumb__inner {
        color: #888888;
    }

    span.el-breadcrumb__item {
      display:inline-flex;
      margin-right: .25rem;
    }

    i.el-separator-style {
        color: #C0C4CC !important;
    }

    div.el-dilatation-title {
        font-size: .75rem;
    }

    .el-xd-login img {
        width: 100% !important;
    }
	.el-dialog.el-dialog--center.file-share{
		border-radius: 20px;
		min-width: 315px;
	}
	.file-share .el-dialog__body{
		background: #eee;
	}
	.file-share .el-dialog__footer{
		cursor: pointer;
	}
</style>
<style lang="css" scoped>
    .el-header {
        line-height: 3.75rem;
    }

    span.custom-tree-node {
        margin-bottom: .5rem;
    }

    div.el-tree-node__content {
        margin-top: .5rem;
    }

    span.indexMenu {
        color: #409EFF;
    }

    ul.row-lan {
        margin: 0;
    }

	ul.row-lan>li {
		position: static;
        display: inline-block;
		border-bottom: 1px solid #333;
		height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/index.vue